import { subMonths } from 'date-fns/subMonths';
import React from 'react';

import { getZonedDate } from '@eika-infrastruktur/date';
import { Chip } from '@eika/button';
import { DateRangeInput } from '@eika/date-range-input';

import useTranslation, { format } from '../../../../hooks/useTranslation';
import { transactionTrackIDs } from '../../../../utils/gtm/trackIDs/transaction';
import { useTransactionFilterContext } from '../TransactionFilterContext/TransactionFilterContext';
import {
    isOneMonthFromToday,
    isOneYearFromToday,
    isSixMonthsFromToday,
    isTwoMonthsFromToday,
} from '../utils/getSearchDates';

const FilterDateRangeInput: React.FC = () => {
    const translation = useTranslation();
    const { dateRange } = useTransactionFilterContext();

    return (
        <section>
            <DateRangeInput
                contentWrapperClassName="transaction-filter-form__date-range-wrapper"
                mainLabel={translation.transactionFilter.choosePeriod}
                fromDate={{
                    placeholder: 'dd.mm.åååå',
                    date: dateRange.fromDate.value,
                    onChange: dateRange.fromDate.set,
                    label: translation.transactionFilter.from,
                    errorMessages: translation.transactionFilter.fromDateError,
                    withHiddenScreenReaderText: false,
                }}
                toDate={{
                    placeholder: 'dd.mm.åååå',
                    date: dateRange.toDate.value,
                    onChange: dateRange.toDate.set,
                    label: translation.transactionFilter.to,
                    errorMessages: translation.transactionFilter.toDateError,
                    withHiddenScreenReaderText: false,
                }}
                maxDate={getZonedDate()}
            />
            <div className="transaction-filter-form__date-chip-wrapper">
                <Chip.Toggle
                    active={
                        isOneYearFromToday(dateRange.fromDate.value) ||
                        (!dateRange.fromDate.value && !dateRange.toDate.value)
                    }
                    data-track-id={transactionTrackIDs.search.id}
                    data-track-linkname={format(translation.transactionFilter.lastMonths, 12)}
                    onClick={() => {
                        dateRange.fromDate.set(subMonths(getZonedDate(), 12));
                        dateRange.toDate.set(getZonedDate());
                    }}
                >
                    {format(translation.transactionFilter.lastMonths, 12)}
                </Chip.Toggle>
                <Chip.Toggle
                    active={isSixMonthsFromToday(dateRange.fromDate.value)}
                    data-track-id={transactionTrackIDs.search.id}
                    data-track-linkname={format(translation.transactionFilter.lastMonths, 6)}
                    onClick={() => {
                        dateRange.fromDate.set(subMonths(getZonedDate(), 6));
                        dateRange.toDate.set(getZonedDate());
                    }}
                >
                    {format(translation.transactionFilter.lastMonths, 6)}
                </Chip.Toggle>
                <Chip.Toggle
                    active={isTwoMonthsFromToday(dateRange.fromDate.value)}
                    data-track-id={transactionTrackIDs.search.id}
                    data-track-linkname={format(translation.transactionFilter.lastMonths, 2)}
                    onClick={() => {
                        dateRange.fromDate.set(subMonths(getZonedDate(), 2));
                        dateRange.toDate.set(getZonedDate());
                    }}
                >
                    {format(translation.transactionFilter.lastMonths, 2)}
                </Chip.Toggle>
                <Chip.Toggle
                    active={isOneMonthFromToday(dateRange.fromDate.value)}
                    data-track-id={transactionTrackIDs.search.id}
                    data-track-linkname={translation.transactionFilter.lastMonth}
                    onClick={() => {
                        dateRange.fromDate.set(subMonths(getZonedDate(), 1));
                        dateRange.toDate.set(getZonedDate());
                    }}
                >
                    {translation.transactionFilter.lastMonth}
                </Chip.Toggle>
            </div>
        </section>
    );
};

export default FilterDateRangeInput;
